import { RenewalApplicationState } from '../App.state';
import { Step, SubmitAnswersRequestBody } from '../../shared/interface';
import { CustomerContactDetails, MatchMakerAnswers } from '../../shared/types';

export const buildSubmitAnswersRequestBody = ({
  state,
  currentStep,
  isEditMode = false,
  matchMakerAnswers = state.matchMakerAnswers,
  contactDetails = state.customerInformation,
  selectedDealer = state.dealer?.id || undefined
}: {
  state: RenewalApplicationState;
  currentStep: Step;
  isEditMode?: boolean;
  matchMakerAnswers?: MatchMakerAnswers;
  contactDetails?: CustomerContactDetails;
  selectedDealer?: string;
}): SubmitAnswersRequestBody => ({
  transactionId: state.transactionId,
  matchMakerAnswers,
  ...(selectedDealer ? { selectedDealer } : {}),
  ...(contactDetails ? { contactDetails } : {}),
  currentStep,
  isEditMode,
  legalEntity: state.legalEntity
});


